import axios from "axios";

export default axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}/api`
})

export const axiosPrivate = axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true
});

export const axiosPublic = axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}/public/api`,
    headers: {'Content-Type': 'application/json'},
});